module.exports = __webpack_public_path__ + "static/img/block3.6f3275b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block3.png
// module id = 8ohk
// module chunks = 1